import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import axios from "axios";

const ArchiveUserLeaveRequestModal = (props) => {
    const {
        show                = false,
        parentId            = "",
        disabled            = false,
        onCancel            = () => { },
        onConfirm           = (userLeaveRequest) => { },
        userLeaveRequest    = null,
        id                  = "archive-user-leave-request-modal",
    } = props;

    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const submit = () => {
        axios.delete(route('web-api.user-leave-request.destroy', {
            user_leave_request: userLeaveRequest.id
        }).toString())
            .then((response) => {
                setSubmitting(false);
                onConfirm(userLeaveRequest);
            })
            .catch((error) => {
                console.log(error);
                setSubmitting(false);
            });
    }

    const handleClose = () => {
        onCancel();
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => handleClose()}
            contentLabel="Delete Leave Request"
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h5 className="modal-title text-eh-navy">Delete Leave Request</h5>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => handleClose()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <p className="mb-3">
                        Are you sure you want to <b className="text-danger">delete</b> this leave request:
                    </p>
                    {!!userLeaveRequest && (
                        <React.Fragment>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Requested Start Date</strong></p>
                                <p className="mb-1 text-eh-off-black">{userLeaveRequest.start_at}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Requested End Date</strong></p>
                                <p className="mb-1 text-eh-off-black">{userLeaveRequest.end_at}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Reason</strong></p>
                                <p className="mb-1 text-eh-off-black">{userLeaveRequest.reason}</p>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className="modal-footer m-0 p-0 d-flex justify-content-start align-items-center border-0">
                    <button
                        type="submit"
                        className="btn btn-danger py-0 px-3 ml-0 py-0 mr-4"
                        onClick={() => setSubmitting(true)}
                        disabled={submitting || disabled}
                    >
                        {"Delete Leave Request"}
                    </button>
                    <button
                        type="button" data-dismiss="modal"
                        className="btn btn-outline-eh-off-black px-3 mr-0"
                        onClick={() => handleClose()}
                    >
                        {"Cancel"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ArchiveUserLeaveRequestModal;
